export default {
      id: "invalid-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#invalid",
      toString: function () {
        return this.url;
      }
    }